import { render, staticRenderFns } from "./PsEventHeader.vue?vue&type=template&id=5b2dbeeb&scoped=true&"
import script from "./PsEventHeader.vue?vue&type=script&lang=js&"
export * from "./PsEventHeader.vue?vue&type=script&lang=js&"
import style0 from "./PsEventHeader.vue?vue&type=style&index=0&id=5b2dbeeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2dbeeb",
  null
  
)

export default component.exports